

<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<bs-listbox [style]="{'width':'100%', 'border': 'none'}"
           [options]="localAddresses?.data ?? []"
           [ngModel]="selectedAddress"
            (ngModelChange)="onSelect($event)" data-testid="selected-address-listbox">

  <ng-template bsTemplate="item" let-option let-index="index">
    <span>{{option.addressLabel}} <ng-container *ngIf="option.addressLine">({{option.addressLine}})</ng-container></span>

  </ng-template>
</bs-listbox>


